import React, {
  ComponentType,
  Fragment,
  useEffect,
  useState,
} from 'react';

import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import {
  Alert,
  Collapse,
  ListItemAvatar,
  ListItemIcon,
  Typography,
} from '@mui/material';
import OnlinePredictionRoundedIcon from '@mui/icons-material/OnlinePredictionRounded';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import api from '../../services/api';
import { useStateContext } from '../../hooks/useStateContext';
import { v4 as uuidv4 } from 'uuid';
import { styled } from '@mui/material/styles';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { auth } from '../../services/auth';
import '@mui/material/styles';
import { group } from '../../schema/group';
import { serviceReservation } from '../../schema/serviceReservation';

import { formatDistanceToNow } from 'date-fns';
import { hu } from 'date-fns/locale';
import { toaster } from '../../services/toaster';
import Snackbar from '@mui/material/Snackbar';
import { createNotification } from '../../reducer/actions/createNotification';
import { useNavigate } from 'react-router-dom';
interface Props {
  showNotifications?: boolean;
  showOnlineUsers?: boolean;
  showUserManagement?: boolean;
  background?: string;
}

export const AvatarMenu: ComponentType<Props> = ({
  showNotifications,
  showOnlineUsers,
  showUserManagement,
                                                   background,
}) => {
  type OnlineUser = {
    id: number;
    name: string;
    avatar: string;
    avatar_color: string;
  };
  const [users, setUsers] = useState<OnlineUser[]>([]);
  const [notifications, setNotifications] = useState<[]>([]);
  const [newNotificationsCount, setNewNotificationsCount] = useState<number>(0);
  const [addingEntity, setAddingEntity] = useState<any>({
    schema: undefined,
  });
  const { user } = useStateContext();

  const [avatarEl, setAvatarEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const [invisible, setInvisible] = React.useState(false);
  const [openOnlineUsers, setOpenOnlineUsers] = React.useState(false);
  const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
  const [notifyEl, setNotifyEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const open = Boolean(avatarEl);
  const userMenuId = uuidv4();
  const [state, setState] = React.useState(false);
  const notifyOpen = Boolean(notifyEl);
  const notifyId = notifyOpen ? 'simpe-notify' : undefined;
  const navigate = useNavigate();

  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      backgroundColor: '#44b700',
      color: '#44b700',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        animation: 'ripple 1.2s infinite ease-in-out',
        border: '1px solid currentColor',
        content: '""',
      },
    },
    '@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(2.4)',
        opacity: 0,
      },
    },
  }));

  //const classes = useBellStyles();
  const [ring, setRing] = useState(false);

  function fetchUsers() {
    if (showOnlineUsers) {
      api.get<OnlineUser[]>('/online-users').then(setUsers);
    }
  }

  function fetchNotifications() {
    if (showNotifications) {
      api.get('/notifications').then((result: any) => {
        setNotifications(result.data);
        setNewNotificationsCount(result.new);
        if (result.show) {
          setState(true);

          console.log('CREATE NOTIFICATION');

          createNotification(`You have ${result.new} unread notification`, ``);
        }
      });
    }
  }

  function handleClickNotification(item: any) {
    api.post(`/notifications/${item?.id}`, {}).then((result: any) => {
      fetchNotifications();
    });

    if (item?.group_id || item?.service_reservation_id) {
      setAddingEntity({
        schema: item?.group_id ? group : serviceReservation,
        row: item?.group_id ? item?.group : item?.service_reservation,
      });
    } else {
      toaster.show({
        icon: 'error',
        message: `Error: Group or Reservation not found`,
        intent: 'danger',
      });
    }
  }

  useEffect(() => {
    fetchUsers();
    const interval = setInterval(fetchUsers, 60_000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 10000);
    return () => clearInterval(interval);
  }, []);
  const handleAvatarClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAvatarEl(e.currentTarget);
  };
  const handleAvatarClose = () => {
    setAvatarEl(null);
  };
  const handleBadgeVisibility = () => {
    setInvisible(!invisible);
  };
  const handleNotifyOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    setNotifyEl(e.currentTarget);
    if (!invisible) {
      handleBadgeVisibility();
    }
  };
  const handleNotifyClose = () => {
    setNotifyEl(null);
  };
  const handleClick = () => {
    setOpenOnlineUsers(!openOnlineUsers);
  };

  const handleClose = () => {
    setState(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (newNotificationsCount) {
        setRing(true);
        setTimeout(() => setRing(false), 300);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <Stack direction="row" spacing={0}>
        {showNotifications && (
          <Button
            sx={{
              minWidth: '52px',
            }}
            aria-describedby={notifyId}
            onClick={handleNotifyOpen}
          >
            <Badge
              color="warning"
              overlap="circular"
              badgeContent={newNotificationsCount}
              //invisible={invisible}
              showZero={false}
            >
              <NotificationsIcon className={''} />
            </Badge>
          </Button>
        )}
        <Button
          sx={{
            minWidth: '52px',
          }}
          aria-describedby={userMenuId}
          onClick={handleAvatarClick}
        >
          <StyledBadge
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            variant="dot"
          >
            <Avatar
              sx={{
                bgcolor: background ? background : (user?.avatar_color ? user?.avatar_color : '#678fff'),
              }}
              src={user?.avatar ? user?.avatar : undefined}
            >
              {!user?.avatar && user.name.charAt(0).toUpperCase()}
            </Avatar>
          </StyledBadge>
        </Button>
      </Stack>

      <Popover
        id={userMenuId}
        open={open}
        anchorEl={avatarEl}
        onClose={handleAvatarClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List
          disablePadding
          sx={{
            minWidth: '300px',
          }}
        >
          {showOnlineUsers && (
            <ListItem key={0} disablePadding>
              <ListItemButton onClick={handleClick}>
                <ListItemIcon
                  sx={{
                    minWidth: '36px',
                  }}
                >
                  <OnlinePredictionRoundedIcon color={'primary'} />
                </ListItemIcon>
                <ListItemText primary="Online Users" />
                {openOnlineUsers ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            </ListItem>
          )}
          <Collapse in={openOnlineUsers} timeout="auto" unmountOnExit>
            <Divider />
            <List component="div" disablePadding>
              {users.map((onlineUser, index) => {
                return (
                  <>
                    {index > 0 && <Divider key={9999999999} />}
                    <ListItem key={index + 11}>
                      <ListItemAvatar>
                        <StyledBadge
                          overlap="circular"
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                          }}
                          variant="dot"
                        >
                          <Avatar
                            sx={{
                              bgcolor: onlineUser?.avatar_color
                                ? onlineUser?.avatar_color
                                : '#678fff',
                            }}
                            src={
                              onlineUser?.avatar
                                ? onlineUser?.avatar
                                : undefined
                            }
                          >
                            {!onlineUser?.avatar &&
                              onlineUser.name.charAt(0).toUpperCase()}
                          </Avatar>
                        </StyledBadge>
                      </ListItemAvatar>
                      <ListItemText
                        primary={onlineUser.name}
                        secondary={onlineUser.id === user.id && '(you)'}
                      />
                    </ListItem>
                  </>
                );
              })}
            </List>
          </Collapse>
          {/* <Divider />
          <ListItem disablePadding>
            <ListItemButton onClick={() => setPasswordDialogOpen(true)}>
              <ListItemIcon
                sx={{
                  minWidth: '36px',
                }}
              >
                <LockResetRoundedIcon />
              </ListItemIcon>
              <ListItemText primary="Change Password" />
            </ListItemButton>
          </ListItem>*/}

          {showUserManagement && (
            <>
              <Divider />
              <ListItemButton
                onClick={() => {
                  navigate('/admin/user-management');
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: '36px',
                  }}
                >
                  <LogoutRoundedIcon color={'primary'} />
                </ListItemIcon>
                <ListItemText primary="User Management" />
              </ListItemButton>
            </>
          )}

          <Divider />
          <ListItemButton
            onClick={(event) => {

              console.log(event);

              const a = auth.logOut();
              console.log(a);
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: '36px',
              }}
            >
              <LogoutRoundedIcon color={'error'} />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </List>
      </Popover>
    {/*  <PasswordDialog
        isOpen={passwordDialogOpen}
        onClose={() => setPasswordDialogOpen(false)}
      />*/}

      <Popover
        id={notifyId}
        open={notifyOpen}
        anchorEl={notifyEl}
        onClose={handleNotifyClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List
          sx={{
            maxWidth: '350px',
          }}
        >
          {notifications.map((notification: any, index: number) => {
            const date = new Date(notification?.created_at);
            date.setMinutes(date.getMinutes() - 1);

            return (
              <>
                <ListItemButton
                  onClick={() => {
                    handleClickNotification(notification);
                  }}
                  alignItems="flex-start"
                  sx={{
                    background: !notification?.seen ? '' : '#f7f7f7',
                  }}
                >
                  <ListItemAvatar>
                    <Avatar
                      sx={{
                        bgcolor: notification.user?.avatar_color
                          ? notification.user?.avatar_color
                          : '#678fff',
                      }}
                      src={
                        notification.user?.avatar
                          ? notification.user?.avatar
                          : undefined
                      }
                    >
                      {!notification.user?.avatar &&
                        notification.user.name.charAt(0).toUpperCase()}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography
                          sx={{
                            display: 'inline',
                            fontWeight: 'bolder',
                            marginRight: '5px',
                          }}
                        >
                          <Typography component="b">
                            {`${
                              notification?.user?.name[0].toUpperCase() +
                              notification?.user?.name.slice(1)
                            }:`}
                          </Typography>
                          <Typography>{notification?.text}</Typography>
                        </Typography>
                      </React.Fragment>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: 'block', marginTop: '2px' }}
                          component="span"
                          variant="body2"
                        >
                          {`${formatDistanceToNow(date, {
                            addSuffix: true,
                            locale: hu,
                          })} `}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                  {!notification?.seen && (
                    <Badge
                      sx={{
                        marginTop: '16px',
                        marginRight: '4px',
                      }}
                      color="primary"
                      variant="dot"
                    >
                      <div></div>
                    </Badge>
                  )}
                </ListItemButton>
                <Divider variant="fullWidth" component="li" />
              </>
            );
          })}
        </List>
      </Popover>

      <Snackbar
        open={state}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={5000}
      >
        <Alert
          onClose={handleClose}
          severity="info"
          variant="filled"
          sx={{ width: '100%' }}
        >
          You have <b>{newNotificationsCount}</b> unread notification
          {newNotificationsCount < 2 ? '' : 's'}
        </Alert>
      </Snackbar>

      {addingEntity?.schema && (
        <></>
        /*<EntityDialog
          schema={addingEntity?.schema}
          onClose={() => {
            return setAddingEntity({
              schema: undefined,
            });
          }}
          row={addingEntity.row}
          properties={addingEntity.row}
          isOpen={addingEntity?.schema}
          onSubmit={(value) => {}}
        />*/
      )}
    </div>
  );
};
